import React, { useContext } from 'react';
import ChevronRight from 'mdi-react/ChevronRightIcon';
import { IconChevronRight } from '@prisjakt/ui/icon';
import { AppContext } from '@prisjakt/ui-app-context';
import {
  StoreLink,
  LinkDesktop,
  HideOnDesktop,
  CircularButton,
} from './styles';
import { DeliveryTimeExperimentType } from 'src/hooks/experiments';

interface IGoToStoreButton {
  deliveryTimeExperimentVal?: DeliveryTimeExperimentType;
}

export const GoToStoreButton: React.FC<IGoToStoreButton> = props => {
  const { t } = useContext(AppContext);
  const title = t('product', 'store.link');

  return (
    <StoreLink data-test="GoToStoreButton">
      <LinkDesktop
        ariaLabel={title}
        color={
          props.deliveryTimeExperimentVal === 'green button'
            ? 'positive'
            : 'primary'
        }
        icon={<ChevronRight />}
        iconPosition="right"
        component={<div />}
        tabIndex={-1}
        deliveryTimeExperimentVal={props.deliveryTimeExperimentVal}
      >
        {title}
      </LinkDesktop>
      <HideOnDesktop>
        <CircularButton
          deliveryTimeExperimentVal={props.deliveryTimeExperimentVal}
        >
          <IconChevronRight color="base0" />
        </CircularButton>
      </HideOnDesktop>
    </StoreLink>
  );
};
